module.exports = __webpack_public_path__ + "img/PM_1.e77184e7.svg";